export default __webpack_public_path__ + "static/media/loader.eb792c73.svg";